<script setup lang="ts">
import { defineEmits, defineProps } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  isApiLoading: boolean;
}>();

const { t } = useI18n();

const emit = defineEmits<{
  (e: "loadMoreBlogs"): void;
}>();
</script>

<template>
  <div class="w-full px-4 md:px-6 xl:px-[72px] pb-4 md:pb-6 xl:pb-10">
    <div
      class="btn-container"
      :class="props.isApiLoading ? 'pointer-events-none opacity-50' : ''"
      @click="emit('loadMoreBlogs')"
    >
      <span class="sf-pro font-normal text-base leading-100p xl:text-xl mr-6">{{
        t("blog.show_more_btn")
      }}</span>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 7L17 17M17 17H7M17 17V7"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<style scoped>
.btn-container {
  @apply flex items-center justify-center w-full border border-divider h-[60px] rounded-[100px] bg-white transition duration-200 text-brown;
}

.btn-container:hover {
  @apply bg-hover border-active text-active cursor-pointer;
}
</style>
